// ============================================================
// Route Path Constants
// ============================================================

export const PATHS = Object.freeze({
  // Super Admin
  SUPER_ADMIN_DASHBOARD: '/super-admin/dashboard',
  SUPER_ADMIN_ORGANIZATIONS: '/super-admin/organizations',
  SUPER_ADMIN_ORGANIZATIONS_ADD: '/super-admin/organizations/add',
  SUPER_ADMIN_ORGANIZATIONS_DETAILS: '/super-admin/organizations/:id',
  SUPER_ADMIN_SCHOOLS: '/super-admin/schools',
  SUPER_ADMIN_SCHOOLS_ADD: '/super-admin/schools/add',
  SUPER_ADMIN_SCHOOLS_DETAILS: '/super-admin/schools/:id',
  SUPER_ADMIN_MODULES: '/super-admin/modules',
  SUPER_ADMIN_ROLE_ACCESS: '/super-admin/role-access',
  SUPER_ADMIN_USERS: '/super-admin/users',
  SUPER_ADMIN_REPORTS: '/super-admin/reports',
  SUPER_ADMIN_SETTINGS: '/super-admin/settings',

  // Public
  LOGIN: '/login',
  ERP_LOGIN: '/ERP',
  FORGOT_PASSWORD: '/forgot-password',
  UNAUTHORIZED: '/unauthorized',

  // Dashboard
  DASHBOARD: '/dashboard',

  // Academic Sessions
  ACADEMIC_SESSIONS: '/academic-sessions',
  ACADEMIC_SESSION_SETTINGS: '/settings/academic-session',

  // Schools
  SCHOOLS: '/schools',

  // Students
  STUDENTS: '/students',
  STUDENT_ADMISSIONS: '/students/add',
  STUDENTS_PROMOTE: '/students/promote',

  // Teachers
  TEACHERS: '/teachers',
  TEACHERS_LIST: '/teachers/list',
  TEACHERS_ADD: '/teachers/add',
  TEACHERS_ASSIGNMENTS: '/teachers/assignments',
  TEACHER_DIRECTORY: '/teacher-directory',
  MY_CLASSES: '/my-classes',
  MY_STUDENTS: '/my-students',
  MY_ATTENDANCE: '/attendance/my-attendance',
  HOMEWORK: '/homework',
  CLASSWORK: '/classwork',
  MY_TIMETABLE: '/my-timetable',
  TEACHER_NOTIFICATIONS: '/teacher-notifications',
  // Staff Management (Org Admin & Principal)
  STAFF_MANAGEMENT: '/staff-management',
  STAFF_MANAGEMENT_DEPARTMENTS: '/staff-management/departments',
  STAFF_MANAGEMENT_DESIGNATIONS: '/staff-management/designations',
  STAFF_MANAGEMENT_LEAVE_TYPES: '/staff-management/leave-types',
  STAFF_MANAGEMENT_DISCIPLINE: '/staff-management/discipline',
  STAFF_MANAGEMENT_STAFF: '/staff-management',
  STAFF_MANAGEMENT_STAFF_ADD: '/staff-management/staff/add',
  STAFF_MANAGEMENT_STAFF_EDIT: '/staff-management/staff/edit/:id',
  STAFF_MANAGEMENT_STAFF_PROFILE: '/staff-management/staff/profile/:id',

  // Fees
  FEES: '/fees',
  FEES_TYPES: '/fees/types',
  FEES_STRUCTURE: '/fees/structure',
  FEES_STRUCTURE_ADD: '/fees/structure/add',
  FEES_STRUCTURE_EDIT: '/fees/structure/edit/:id',
  FEES_STRUCTURE_COMPONENTS: '/fees/structure/:id/components',
  FEES_STRUCTURE_INSTALLMENTS: '/fees/structure/:structureId/components/:itemId/installments',
  FEES_ASSIGN: '/fees/assign',
  FEES_COLLECT: '/fees/collect',
  FEES_TRANSACTIONS: '/fees/transactions',
  FEES_PENDING: '/fees/pending',

  // Reports
  FEE_REPORTS: '/fees/reports',
  // Attendance
  ATTENDANCE: '/attendance',
  ATTENDANCE_DAILY: '/attendance/daily',
  ATTENDANCE_QR_SCANNER: '/attendance/qr-scanner',
  ATTENDANCE_REPORTS: '/attendance/daily',
  ATTENDANCE_MY_HISTORY: '/attendance/my-history',
  ATTENDANCE_SETTINGS: '/attendance/settings',
  STUDENT_ATTENDANCE_SETTINGS: '/student-attendance-settings',
  STUDENT_ATTENDANCE_DAILY: '/attendance/student-attendance',

  // Exams
  EXAM_SCHEDULE: '/exams/schedule',
  EXAM_RESULTS: '/exams/results',

  // Reports
  REPORTS: '/reports',

  // Users
  USERS: '/users',
  PERMISSIONS: '/permissions',

  // Settings
  SETTINGS: '/settings',

  // Leaves
  LEAVES: '/leaves',
  LEAVES_APPLY: '/leaves/my',
  MY_LEAVES: '/leaves/my',
  LEAVE_REQUESTS: '/leaves',

  // Expenses
  EXPENSES: '/expenses',
  EXPENSE_DASHBOARD: '/expenses/dashboard',
  EXPENSES_LIST: '/expenses',
  EXPENSE_CATEGORIES: '/expenses/categories',

  // Income
  INCOME: '/income',
  INCOME_DASHBOARD: '/income/dashboard',
  INCOMES: '/income',
  INCOME_CATEGORIES: '/income/categories',
});
